import type { AlertsEntity } from '../../alerts/Alerts.entity';
import { AlertsScreen } from '../../alerts/AlertsScreen';
import type { TRenderScreen, TSettingsScreenOptions } from '../SettingsScreenRendererService';

export function renderAlertsScreen(screen: AlertsEntity, options: TSettingsScreenOptions): TRenderScreen {
  return () => <AlertsScreen stack={options.stack} screen={screen} />;
}
